import { __read } from "tslib";
import { useMemo, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
export function extractTimeThrows(time) {
    if (!time) {
        throw new Error('Time is undefined');
    }
    var match = time.match(/^(\d{1,2}):(\d{1,2})$/);
    if (!match) {
        throw new Error('Cannot extract time');
    }
    var _a = __read(match, 3), hStr = _a[1], mStr = _a[2];
    if (!hStr) {
        throw new Error('Cannot extract hours');
    }
    if (!mStr) {
        throw new Error('Cannot extract minutes');
    }
    var hour = Number(hStr);
    var minute = Number(mStr);
    if (hour > 23) {
        throw new Error('Hours should be from 0 to 23');
    }
    if (minute > 59) {
        throw new Error('Minutes should be from 0 to 59');
    }
    return { hour: hour, minute: minute };
}
export function extractCompleteTime(time) {
    try {
        return extractTimeThrows(time);
    }
    catch (e) {
        return undefined;
    }
}
export function extractTimeParts(time) {
    if (!time) {
        return undefined;
    }
    var valid = isPotentialTimeString(time);
    if (!valid) {
        return undefined;
    }
    var _a = __read(time.split(':'), 2), hourStr = _a[0], minuteStr = _a[1];
    var hour = hourStr ? Number(hourStr) : undefined;
    var minute = minuteStr ? Number(minuteStr) : undefined;
    var timeObj = {
        hour: isValidHour(hour) ? hour : undefined,
        minute: isValidMinute(minute) ? minute : undefined,
    };
    return timeObj;
}
export function timeToString(time) {
    return timeNumberToString(time.hour) + ":" + timeNumberToString(time.minute);
}
export function timeNumberToString(timeNumber, placeholder) {
    if (placeholder === void 0) { placeholder = ''; }
    if (timeNumber === undefined) {
        return placeholder;
    }
    if (timeNumber < 10) {
        return '0' + timeNumber;
    }
    return String(timeNumber);
}
export function getNumbers(_a) {
    var timeType = _a.timeType, steps = _a.steps, minNumber = _a.minNumber, maxNumber = _a.maxNumber;
    minNumber = minNumber || 0;
    maxNumber = maxNumber || (timeType === 'hour' ? 23 : 59);
    var numbers = [];
    for (var i = minNumber; i <= maxNumber; i++) {
        if (!steps || i % steps === 0) {
            numbers.push(i);
        }
    }
    return numbers;
}
export function isTimeComplete(time) {
    return time.hour !== undefined && time.minute !== undefined;
}
export function useIds(idProp) {
    var uniqueIdRef = useRef(uuidv4());
    return useMemo(function () {
        var _id = idProp || uniqueIdRef.current;
        return {
            selectorId: _id + '_selector',
            inputId: _id,
            optionIdBase: _id + '_option_',
        };
    }, [idProp]);
}
export function isHourType(timeType) {
    return timeType === 'hour';
}
export function isMinuteType(timeType) {
    return timeType === 'minute';
}
export function isValidHour(hour) {
    return hour !== undefined && hour < 24;
}
export function isValidMinute(minute) {
    return minute !== undefined && minute < 60;
}
/** Difficult to name the function, but this is true for [1] [1:] [1:1] [12:01] [] */
export function isPotentialTimeString(time) {
    return /^\d{0,2}(?::\d{0,2})?$/.test(time);
}
//# sourceMappingURL=utils.js.map